export default class ResultNaviMore {
  constructor (clickedResultNaviMoreElem, resultNaviMoreElem, hiddenHeight) {
    this.hideNaviMoreButton(clickedResultNaviMoreElem, resultNaviMoreElem, hiddenHeight);

    clickedResultNaviMoreElem.addEventListener('click', {
      params: { resultNaviMoreElem: resultNaviMoreElem },
      handleEvent: this.addEvent
    });
  }

  hideNaviMoreButton (clickedResultNaviMoreElem, resultNaviMoreElem, hiddenHeight) {
    const fixedHeight = resultNaviMoreElem.clientHeight;

    if (fixedHeight < hiddenHeight) {
      clickedResultNaviMoreElem.classList.add('u-hide');
    }
  }

  addEvent (event) {
    event.preventDefault();
    const target = event.currentTarget;

    target.classList.add('is-active');
    this.params.resultNaviMoreElem.parentNode.classList.add('is-full');
  }
}
